import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import useThreeDotsOptions from "./useThreeDotsOptions";
import { updateRates } from "../../../Redux/Slices/rates.slice";

const ListDropdown = ({ detail }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { agriTechThreeDotsPopoverId } = useSelector((state) => state.rates);

  const [open, setOpen] = useState(false);

  const threeDotsOptions = useThreeDotsOptions().filter(
    (item) => item.hasPermission,
  );

  const onOptionClick = async (optionId) => {
    dispatch(
      updateRates({
        key: "currentAgriTechRate",
        value: detail,
      }),
    );

    setOpen(false);

    switch (optionId) {
      case 1:
        navigate(`/add-agri-tech-rate/${detail.id}`);
        break;
      case 2:
        dispatch(
          updateRates({
            key: "deleteAgriTechModal",
            value: true,
          }),
        );
        break;

      default:
        break;
    }
  };

  const handleOpenChange = (state) => {
    setOpen(state);

    dispatch(
      updateRates({
        key: "agriTechThreeDotsPopoverId",
        value: detail.id,
      }),
    );
  };

  // if three dots has no items (depending on the permission) then return empty fragments
  if (!threeDotsOptions.length) {
    return <div />;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open && agriTechThreeDotsPopoverId === detail.id}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1"
          style={{
            width: "156px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
          }}
        >
          {threeDotsOptions.map((option) => (
            <button
              type="button"
              className={`w-full flex items-center gap-x-3 px-3 py-2 group 
              ${
                option.id === 2
                  ? "hover:bg-light-alert-red-hover"
                  : "hover:bg-background"
              }
              `}
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}
              <p
                className={`font-aileron text-xs font-semibold capitalize ${
                  option.id === 2
                    ? "text-alert-red group-hover:text-alert-red-hover"
                    : "text-dark-gray group-hover:text-black"
                }`}
              >
                {option.value}
              </p>
            </button>
          ))}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
